import { useEffect } from 'react';
import AOS from 'aos';
import { BlocksRenderer } from '../../BlockRenderer';
const SectionTitle = (props) => {
    const { titleClass, subtitleClass, bottomSubTitleClass, descClass, secondDescClass, effectClass, animateName, animateDelay, animateDuration } = props;

    useEffect(() => {
        AOS.init();
    })

    return (
        <div className={props.sectionClass} data-aos={animateName ? animateName : ''} data-aos-delay={animateDelay ? animateDelay : ''} data-aos-duration={animateDuration ? animateDuration : ''}>
            {subtitleClass ? <h1 className={props.subtitleClass} title={props.subtitle}>{props.subtitle}</h1> : ''}
            {titleClass ? <h2 className={props.titleClass} title={props.subtitle}>{props.title}</h2> : ''}
            {bottomSubTitleClass ? <div className={props.bottomSubTitleClass}>{props.bottomSubTitle}</div> : ''}
            {descClass ? <div className={props.descClass}>
                <BlocksRenderer content={props.description || []}/>
                </div> : ''}
            {secondDescClass ? <div className={props.secondDescClass}>{props.secondDescription}</div> : ''}
            {effectClass ? <div className={props.effectClass}></div> : ''}
        </div>
    );
}

export default SectionTitle